import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "styles/globalStyles";
import { theme } from "styles/theme";

export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
);